let passwordResetToken: string | null = null;

export function capturePasswordResetToken() {
  if (window.location.pathname !== "/reset-password") return;
  const fragment = new URLSearchParams(window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash);
  const token = fragment.get("token");
  if (token) passwordResetToken = token;
  if (window.location.hash) {
    window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}`);
  }
}

export function getPasswordResetToken() {
  return passwordResetToken;
}
